module.exports = __webpack_public_path__ + "img/futureLabPT.8c4550a5.png";